import { render, staticRenderFns } from "./HotspotAttachment.vue?vue&type=template&id=6e7c4bd3&scoped=true&"
import script from "./HotspotAttachment.vue?vue&type=script&lang=js&"
export * from "./HotspotAttachment.vue?vue&type=script&lang=js&"
import style0 from "./HotspotAttachment.vue?vue&type=style&index=0&id=6e7c4bd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7c4bd3",
  null
  
)

export default component.exports